import { createApp } from 'vue'
import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import './assets/css/Global.css'
import App from './App.vue'
import router from '@/router'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import axios from 'axios'
import VueLazyload from 'vue-lazyload'
import '@fortawesome/fontawesome-free/css/all.css'; // 引入 Font Awesome 的 CSS 文件

const app = createApp(App)
const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);
app.use(ElementPlus)
app.use(router)
app.use(pinia);
app.use(VueLazyload);
app.mount('#app')
console.log("项目开始")



axios.get('http://39.105.131.120:8000/fontManagement/font').then(res => {
    console.log(res.data)
    var styleElement = document.createElement('style');
    let fontFaceRule=''
    for(let i=0;i<res.data.length;i++){
        fontFaceRule=fontFaceRule+`@font-face {
            font-family: '${res.data[i].font_name}';
            src: url('${res.data[i].font_file}');
        }\n`
    }
    console.log(fontFaceRule)
    styleElement.innerHTML = fontFaceRule;
    document.head.appendChild(styleElement);
}).then(err => {
    console.log(err)
})